/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { RedshiftServerlessNamespace } from '../models/RedshiftServerlessNamespace';

export class RedshiftServerlessNamespaces {
  'namespaces': Array<RedshiftServerlessNamespace>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "namespaces",
      "baseName": "namespaces",
      "type": "Array<RedshiftServerlessNamespace>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RedshiftServerlessNamespaces.attributeTypeMap;
  }

  public constructor() {
  }
}

